export enum ETipoConfiguracao {
  ATIVAR = "ativar",
  CONFIGURAR = "configurar"
}
